import { render, staticRenderFns } from "./LandingTermsTransaction.vue?vue&type=template&id=06622562"
import script from "./LandingTermsTransaction.vue?vue&type=script&lang=js"
export * from "./LandingTermsTransaction.vue?vue&type=script&lang=js"
import style0 from "./LandingTermsTransaction.vue?vue&type=style&index=0&id=06622562&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports